import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { 
  ClipboardDocumentListIcon,
  ChartBarIcon, 
  BuildingOfficeIcon,
  BeakerIcon,
  CurrencyDollarIcon,
  BanknotesIcon,
  ScaleIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';
import ExpenseForm from '../dataentry/ExpenseForm';
import IncomeForm from '../dataentry/IncomeForm';
import GoatFeedForm from './forms/GoatFeedForm';

const GoatDataEntryMenu: React.FC = () => {
  return (
    <div className="container-mobile py-6 space-y-6">
      <div className="text-center">
        <ClipboardDocumentListIcon className="h-16 w-16 text-green-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Goat Data Entry</h1>
        <p className="text-lg text-gray-600">
          Select a module to enter goat farming data
        </p>
      </div>

      {/* Quick Actions */}
      <div className="card p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Link
            to="/goat/master/new"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <BuildingOfficeIcon className="h-8 w-8 text-green-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Manage Goat</p>
              <p className="text-sm text-gray-500">Add new goat master data</p>
            </div>
          </Link>

          <Link
            to="/goat/data-entry/feed"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <BeakerIcon className="h-8 w-8 text-amber-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Feed</p>
              <p className="text-sm text-gray-500">Add new feed log entry</p>
            </div>
          </Link>

          <Link
            to="/goat/data-entry/expense"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <CurrencyDollarIcon className="h-8 w-8 text-red-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Expense</p>
              <p className="text-sm text-gray-500">Add new expense log entry</p>
            </div>
          </Link>

          <Link
            to="/goat/data-entry/income"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <BanknotesIcon className="h-8 w-8 text-emerald-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Income</p>
              <p className="text-sm text-gray-500">Add new income log entry</p>
            </div>
          </Link>

          <Link
            to="/goat/weight-register"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ScaleIcon className="h-8 w-8 text-blue-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Weight Register</p>
              <p className="text-sm text-gray-500">Track and record goat weight measurements</p>
            </div>
          </Link>

          <Link
            to="/goat/health-logs/vaccination/new"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ShieldCheckIcon className="h-8 w-8 text-purple-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Vaccination</p>
              <p className="text-sm text-gray-500">Add new health/vaccination record</p>
            </div>
          </Link>

          <Link
            to="/goat/breeding/new"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ChartBarIcon className="h-8 w-8 text-orange-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Breeding Log</p>
              <p className="text-sm text-gray-500">Add new breeding record</p>
            </div>
          </Link>

          <Link
            to="/goat/kidding/new"
            className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ChartBarIcon className="h-8 w-8 text-pink-600 mr-3" />
            <div>
              <p className="font-medium text-gray-900">Kidding Log</p>
              <p className="text-sm text-gray-500">Add new kidding record</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

const GoatDataEntry: React.FC = () => {
  return (
    <Routes>
      <Route index element={<GoatDataEntryMenu />} />
      <Route path="feed" element={<GoatFeedForm />} />
      <Route path="expense" element={<ExpenseForm />} />
      <Route path="income" element={<IncomeForm />} />
    </Routes>
  );
};

export default GoatDataEntry;
